import { createElearningHtmlSanitizer } from "@monorepo/shared/learning";
import sanitizeHtml from "sanitize-html";

export const sanitizeLearningHtml = createElearningHtmlSanitizer(sanitizeHtml);
